// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"489156da","137":"1b8da4a2","237":"60ddd3fe","240":"f9fb72f2","458":"a65b6c11","611":"2ecb908e","661":"11011bd4","676":"736d344d","708":"2ef30132","881":"f0c324ef","965":"274df00d"}[chunkId] + ".chunk.js";
};